import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedTeacher } from '../../features/waliKelasSlice';
import close from '../../assets/icons/close.svg';
import plus from '../../assets/icons/plus.svg';
import ModalTeacher from './ModalTeacher';

function TeacherSelect() {
    const dispatch = useDispatch();
    const { selectedTeacher } = useSelector((state) => state.waliKelas);
    const [modalActive, setModalActive] = useState(false);

    return (
        <div className='wrapper-container-jabatan'>
            {selectedTeacher && (
                <div className='container-jabatan' style={{ width: '700px' }}>
                    <p>{selectedTeacher.nama}</p>
                    <img src={close} alt="" onClick={() => dispatch(clearSelectedTeacher())} />
                </div>
            )}
            {!selectedTeacher && (
                <div className='container-jabatan btn-plus' onClick={() => setModalActive(true)}>
                    <img src={plus} alt="" />
                </div>
            )}
            {modalActive && <ModalTeacher onClose={() => setModalActive(false)} />}
        </div>
    );
}

export default TeacherSelect;
